// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-TvT","buttons":"styles_buttons__Ieyvk"};